import React, { useEffect, useState } from "react";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification, message, Tooltip, Space } from "antd";
import { FileExcelOutlined, FileTextOutlined } from "@ant-design/icons";
import getDetalleVisitaPorTipo from "../../../../services/visitas_tecnicas/getDetalleVisitasportipoService";
import { useSelector } from "react-redux";

const Export_diagnostico_parte1 = () => {
  const [dataCompleta, setDataCompleta] = useState([]);
  const [loading, setLoading] = useState(false); // Estado de carga
  const [loadingExcel, setLoadingExcel] = useState(false); // Estado para Excel
  const [loadingJson, setLoadingJson] = useState(false); // Estado para JSON
  const usernameFromState = useSelector((state) => state.auth.user);

  const fetchDetalleVisitas = async () => {
    try {
      const response = await getDetalleVisitaPorTipo(
        2,
        usernameFromState.email
      );
      const { status, results } = response;

      if (status === 200) {
        setDataCompleta(results);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch detalle visitas data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchDetalleVisitas()]);
      setLoading(false);
    };

    fetchData();
  }, []);

  const exportToExcel = async () => {
    try {
      if (dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingExcel(true);

      const workbook = new ExcelJS.Workbook();

      // Cargar la plantilla de Excel
      const templateResponse = await fetch(
        "/assets/plantilla_diagnostico_parte1.xlsx"
      );
      const templateBuffer = await templateResponse.arrayBuffer();

      await workbook.xlsx.load(templateBuffer);

      const worksheet = workbook.getWorksheet(1); // Selecciona la hoja de trabajo

      let currentRow = 4; // Fila inicial

      dataCompleta.forEach((item) => {
        const sectionRowStart = currentRow; // Fila de inicio para esta entrada
        let maxRow = currentRow; // Variable para rastrear la fila más baja ocupada
        //Paso 1
        // Llenar columnas principales
        worksheet.getCell(`A${sectionRowStart}`).value =
          item.detalle.codigo_sir || "";
        worksheet.getCell(`B${sectionRowStart}`).value =
          item.detalle.fecha_registro || "";
        worksheet.getCell(`C${sectionRowStart}`).value =
          item.detalle.nombre_participante || "";
        worksheet.getCell(`D${sectionRowStart}`).value =
          item.detalle.nombre_proyecto || "";

        worksheet.getCell(`E${sectionRowStart}`).value =
          item.detalle.asociativo_individual || "";
        worksheet.getCell(`F${sectionRowStart}`).value =
          item.detalle.codigo_pre || "";

        // Manejar lista de participantes
        if (
          item.detalle.lista_participantes &&
          item.detalle.lista_participantes.filter(
            (item) => item !== null && item !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_participantes.forEach((participante) => {
            worksheet.getCell(`G${currentRow}`).value =
              participante.nombre || "";
            worksheet.getCell(`H${currentRow}`).value =
              participante.cedula || "";
            worksheet.getCell(`I${currentRow}`).value =
              participante.telefono || "";

            currentRow++; // Incrementar fila solo al recorrer la lista
          });
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        // Llenar columnas adicionales en la fila base
        worksheet.getCell(`J${sectionRowStart}`).value =
          item.detalle.email_participante || "";
        worksheet.getCell(`K${sectionRowStart}`).value =
          item.detalle.direccion_proyecto || "";
        worksheet.getCell(`L${sectionRowStart}`).value =
          item.detalle.departamento || "";
        worksheet.getCell(`M${sectionRowStart}`).value =
          item.detalle.municipio || "";
        worksheet.getCell(`N${sectionRowStart}`).value =
          item.detalle.actividad_economica_proyecto || "";
        worksheet.getCell(`O${sectionRowStart}`).value =
          item.detalle.sector_economico || "";
        worksheet.getCell(`P${sectionRowStart}`).value =
          item.detalle.tiempo_funcionamiento_proyecto || "";
        worksheet.getCell(`Q${sectionRowStart}`).value =
          item.detalle.tiene_trabajadores || "";
        worksheet.getCell(`R${sectionRowStart}`).value =
          item.detalle.trabajadores_hombres || "";
        worksheet.getCell(`S${sectionRowStart}`).value =
          item.detalle.trabajadores_mujeres || "";
        worksheet.getCell(`T${sectionRowStart}`).value =
          item.detalle.vinculacion_trabajadores?.join(", ") || "";
        worksheet.getCell(`U${sectionRowStart}`).value =
          item.detalle.otros_vinculacion_trabajadores || "";

        //Paso 2
        worksheet.getCell(`V${sectionRowStart}`).value =
          item.detalle.trabajan_miembros_nucleo_familiar || "";
        // Manejar lista de participantes
        if (
          item.detalle.lista_personas_trabajan_proyecto &&
          item.detalle.lista_personas_trabajan_proyecto.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_personas_trabajan_proyecto.forEach((item) => {
            worksheet.getCell(`W${currentRow}`).value = item.tipo_familia || "";
            worksheet.getCell(`X${currentRow}`).value =
              item.familiar_otro || "";
            worksheet.getCell(`Y${currentRow}`).value =
              item.administracion || "";
            worksheet.getCell(`Z${currentRow}`).value = item.contabilidad || "";
            worksheet.getCell(`AA${currentRow}`).value = item.produccion || "";
            worksheet.getCell(`AB${currentRow}`).value = item.ventas || "";
            currentRow++; // Incrementar fila solo al recorrer la lista
          });
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        worksheet.getCell(`AC${sectionRowStart}`).value =
          item.detalle.personas_trabajan_proyecto_remuneracion || "";
        worksheet.getCell(`AD${sectionRowStart}`).value =
          item.detalle.parte_asociacion_coperativa || "";
        worksheet.getCell(`AE${sectionRowStart}`).value =
          item.detalle.cuenta_mision_vision || "";
        worksheet.getCell(`AF${sectionRowStart}`).value =
          item.detalle.cuenta_rut || "";
        worksheet.getCell(`AG${sectionRowStart}`).value =
          item.detalle.responsable_iva || "";
        worksheet.getCell(`AH${sectionRowStart}`).value =
          item.detalle.tienes_definido_procesos || "";
        worksheet.getCell(`AI${sectionRowStart}`).value =
          item.detalle.procesos_definidos || "";
        worksheet.getCell(`AJ${sectionRowStart}`).value =
          item.detalle.nivel_satisfaccion || "";
        worksheet.getCell(`AK${sectionRowStart}`).value =
          item.detalle.grado_compromiso || "";
        worksheet.getCell(`AL${sectionRowStart}`).value =
          item.detalle.deciciones_interior_proyecto || "";
        worksheet.getCell(`AM${sectionRowStart}`).value =
          item.detalle.temas_toman_deciciones || "";
        worksheet.getCell(`AN${sectionRowStart}`).value =
          item.detalle.debilidades_negocio || "";
        worksheet.getCell(`AO${sectionRowStart}`).value =
          item.detalle.resibido_asistencia_entidades || "";
        worksheet.getCell(`AP${sectionRowStart}`).value =
          item.detalle.entidad_recibio_asistencia || "";
        worksheet.getCell(`AQ${sectionRowStart}`).value =
          item.detalle.fortaleza_representativa || "";
        worksheet.getCell(`AR${sectionRowStart}`).value =
          item.detalle.debilidad_representativa || "";

        //Paso 3
        worksheet.getCell(`AS${sectionRowStart}`).value =
          item.detalle.productos_representativos || "";
        worksheet.getCell(`AT${sectionRowStart}`).value =
          item.detalle.realizan_controles_actividades || "";
        worksheet.getCell(`AU${sectionRowStart}`).value =
          item.detalle.registro_control_inventario || "";
        worksheet.getCell(`AV${sectionRowStart}`).value =
          item.detalle.cuenta_licencias || "";
        worksheet.getCell(`AW${sectionRowStart}`).value =
          item.detalle.respuesta_cuenta_licencia || "";
        worksheet.getCell(`AX${sectionRowStart}`).value =
          item.detalle.adecuada_residuos_solidos || "";
        worksheet.getCell(`AY${sectionRowStart}`).value =
          item.detalle.respuesta_adecuada_residuos_solidos || "";
        worksheet.getCell(`AZ${sectionRowStart}`).value =
          item.detalle.fortaleza_representativa_tema_produccion || "";
        worksheet.getCell(`BA${sectionRowStart}`).value =
          item.detalle.debilidad_representativa_tema_produccion || "";

        //Paso 4
        worksheet.getCell(`BB${sectionRowStart}`).value =
          item.detalle.tiene_identificado_clientes || "";
        worksheet.getCell(`BC${sectionRowStart}`).value =
          item.detalle.dia_hoy_clientes_han || "";
        worksheet.getCell(`BD${sectionRowStart}`).value =
          item.detalle.competente_directo || "";
        worksheet.getCell(`BE${sectionRowStart}`).value =
          item.detalle.elementos_diferenciadores || "";
        worksheet.getCell(`BF${sectionRowStart}`).value =
          item.detalle.medio_atraer_clientes || "";
        worksheet.getCell(`BG${sectionRowStart}`).value =
          item.detalle.temporadas_aumentar_ventas?.join(", ") || "";
        worksheet.getCell(`BH${sectionRowStart}`).value =
          item.detalle.fortaleza_representativa_mercadeo_ventas || "";
        worksheet.getCell(`BI${sectionRowStart}`).value =
          item.detalle.debilidad_representativa_mercadeo_ventas || "";

        //Paso 5
        worksheet.getCell(`BJ${sectionRowStart}`).value =
          item.detalle.acceso_productos_sector_financiero || "";
        worksheet.getCell(`BK${sectionRowStart}`).value =
          item.detalle.productos_sector_financiero_proyecto?.join(", ") || "";
        worksheet.getCell(`BL${sectionRowStart}`).value =
          item.detalle.otros_productos_sector_financiero_proyecto || "";
        worksheet.getCell(`BM${sectionRowStart}`).value =
          item.detalle.valor_activos_fijos_mes || "";
        worksheet.getCell(`BN${sectionRowStart}`).value =
          item.detalle.valor_deudas_pasivo_fijos_mes || "";
        worksheet.getCell(`BO${sectionRowStart}`).value =
          item.detalle.periodicidad_ventas || "";
        worksheet.getCell(`BP${sectionRowStart}`).value =
          item.detalle.valor_inventario_perico_costo || "";
        worksheet.getCell(`BQ${sectionRowStart}`).value =
          item.detalle.ingresos_proyecto_ultimo_periodo || "";
        worksheet.getCell(`BR${sectionRowStart}`).value =
          item.detalle.gastos_proyecto_mensualmente || "";

        if (
          item.detalle.lista_periodicidad_ventas &&
          item.detalle.lista_periodicidad_ventas.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_periodicidad_ventas.forEach((item) => {
            worksheet.getCell(`BS${currentRow}`).value =
              item.articulo_referencia || "";
            worksheet.getCell(`BT${currentRow}`).value =
              item.periodicidad || "";
            worksheet.getCell(`BU${currentRow}`).value =
              item.precio_venta || "";
            worksheet.getCell(`BV${currentRow}`).value = item.medida || "";
            worksheet.getCell(`BW${currentRow}`).value = item.cantidad || "";
            worksheet.getCell(`BX${currentRow}`).value = item.total || "";
            currentRow++; // Incrementar fila solo al recorrer la lista
          });
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        if (
          item.detalle.lista_costo_ventas &&
          item.detalle.lista_costo_ventas.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_costo_ventas.forEach((item) => {
            worksheet.getCell(`BY${currentRow}`).value =
              item.articulo_referencia || "";
            worksheet.getCell(`BZ${currentRow}`).value =
              item.periodicidad || "";
            worksheet.getCell(`CA${currentRow}`).value =
              item.precio_venta || "";
            worksheet.getCell(`CB${currentRow}`).value = item.medida || "";
            worksheet.getCell(`CC${currentRow}`).value = item.cantidad || "";
            worksheet.getCell(`CD${currentRow}`).value = item.total || "";
            currentRow++; // Incrementar fila solo al recorrer la lista
          });
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        worksheet.getCell(`CE${sectionRowStart}`).value =
          item.detalle.gastos_proyecto_separados_personales || "";
        worksheet.getCell(`CF${sectionRowStart}`).value =
          item.detalle.fortaleza_representativa_temas_financieros || "";
        worksheet.getCell(`CG${sectionRowStart}`).value =
          item.detalle.debilidad_representativa_temas_financieros || "";

        //Paso 6

        if (
          item.detalle.lista_ambito_mercado_actividades_productivas &&
          item.detalle.lista_ambito_mercado_actividades_productivas.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_ambito_mercado_actividades_productivas.forEach(
            (item) => {
              worksheet.getCell(`CH${currentRow}`).value = item.sector || "";
              worksheet.getCell(`CI${currentRow}`).value =
                item.sector_otro || "";
              worksheet.getCell(`CJ${currentRow}`).value = item.local || "";
              worksheet.getCell(`CK${currentRow}`).value = item.municipal || "";
              worksheet.getCell(`CL${currentRow}`).value =
                item.departamental || "";
              worksheet.getCell(`CM${currentRow}`).value = item.nacional || "";
              currentRow++; // Incrementar fila solo al recorrer la lista
            }
          );
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        if (
          item.detalle.lista_nivel_influencia_diferentes_sectores &&
          item.detalle.lista_nivel_influencia_diferentes_sectores.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_nivel_influencia_diferentes_sectores.forEach(
            (item) => {
              worksheet.getCell(`CN${currentRow}`).value = item.sector || "";
              worksheet.getCell(`CO${currentRow}`).value =
                item.sector_otro || "";
              worksheet.getCell(`CP${currentRow}`).value = item.local || "";
              worksheet.getCell(`CQ${currentRow}`).value = item.municipal || "";
              worksheet.getCell(`CR${currentRow}`).value =
                item.departamental || "";
              worksheet.getCell(`CS${currentRow}`).value = item.nacional || "";
              currentRow++; // Incrementar fila solo al recorrer la lista
            }
          );
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        if (
          item.detalle.lista_expectativas_crecimiento_sector &&
          item.detalle.lista_expectativas_crecimiento_sector.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_expectativas_crecimiento_sector.forEach((item) => {
            worksheet.getCell(`CT${currentRow}`).value = item.sector || "";
            worksheet.getCell(`CU${currentRow}`).value = item.sector_otro || "";
            worksheet.getCell(`CV${currentRow}`).value = item.local || "";
            worksheet.getCell(`CW${currentRow}`).value = item.municipal || "";
            worksheet.getCell(`CX${currentRow}`).value =
              item.departamental || "";
            worksheet.getCell(`CY${currentRow}`).value = item.nacional || "";
            currentRow++; // Incrementar fila solo al recorrer la lista
          });
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        if (
          item.detalle.lista_compras_adquisicion_insumos_sector &&
          item.detalle.lista_compras_adquisicion_insumos_sector.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_compras_adquisicion_insumos_sector.forEach(
            (item) => {
              worksheet.getCell(`CZ${currentRow}`).value = item.sector || "";
              worksheet.getCell(`DA${currentRow}`).value =
                item.sector_otro || "";
              worksheet.getCell(`DB${currentRow}`).value = item.local || "";
              worksheet.getCell(`DC${currentRow}`).value = item.municipal || "";
              worksheet.getCell(`DD${currentRow}`).value =
                item.departamental || "";
              worksheet.getCell(`DE${currentRow}`).value = item.nacional || "";
              currentRow++; // Incrementar fila solo al recorrer la lista
            }
          );
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        worksheet.getCell(`DF${sectionRowStart}`).value =
          item.detalle.oportunidades_del_sector_economico || "";
        worksheet.getCell(`DG${sectionRowStart}`).value =
          item.detalle.amenazas_del_sector_economico || "";

        //Parte 7

        if (
          item.detalle.lista_activos_insumos_proyecto_productivo &&
          item.detalle.lista_activos_insumos_proyecto_productivo.filter(
            (n) => n !== null && n !== undefined
          ).length > 0
        ) {
          currentRow = sectionRowStart; // Fila de inicio para esta entrada
          item.detalle.lista_activos_insumos_proyecto_productivo.forEach(
            (item) => {
              worksheet.getCell(`DH${currentRow}`).value =
                item.activo_insumo || "";
              worksheet.getCell(`DI${currentRow}`).value = item.fuente || "";
              worksheet.getCell(`DJ${currentRow}`).value =
                item.otra_fuente || "";
              worksheet.getCell(`DK${currentRow}`).value = item.estado || "";
              worksheet.getCell(`DL${currentRow}`).value =
                item.esta_en_uso || "";
              currentRow++; // Incrementar fila solo al recorrer la lista
            }
          );
          maxRow = Math.max(maxRow, currentRow);
        } else {
          maxRow = Math.max(maxRow, sectionRowStart + 1);
        }

        worksheet.getCell(`DM${sectionRowStart}`).value =
          item.detalle.observaciones_activos_insumos_entregados_proyecto || "";
        worksheet.getCell(`DN${sectionRowStart}`).value =
          item.detalle.insumos_utilizan_totalmente_proyecto || "";
        worksheet.getCell(`DO${sectionRowStart}`).value =
          item.detalle.razones_insumos_no_fueron_utilizados_totalidad || "";
        worksheet.getCell(`DP${sectionRowStart}`).value =
          item.detalle.porcentaje_utilidades_compra_insumos || "";
        worksheet.getCell(`DQ${sectionRowStart}`).value =
          item.detalle.fuente || "";
        worksheet.getCell(`DR${sectionRowStart}`).value = item.name || "";
        worksheet.getCell(`DS${sectionRowStart}`).value = item.email || "";
        worksheet.getCell(`DT${sectionRowStart}`).value = item.estado || "";

        for (let row = sectionRowStart; row <= maxRow; row++) {
          worksheet.getCell(`A${row}`).value = item.detalle.codigo_sir || "";
        }
        // Asegurar que `currentRow` inicie en la fila siguiente al último dato escrito
        currentRow = maxRow;
      });

      // Descargar el archivo modificado
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "Informe-diagnostico.xlsx");
      // Cerrar notificación de carga y mostrar éxito
      notification.success({
        message: "Éxito",
        description: "Excel exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar Excel:", error);
      // Cerrar notificación de carga y mostrar éxito
      notification.error({
        message: "Error",
        description: "No se pudo exportar el Excel.",
        duration: 3,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const exportToJSON = async () => {
    try {
      if (!dataCompleta || dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }

      setLoading(true);
      // Convertir data a JSON y descargar
      const jsonBlob = new Blob([JSON.stringify(dataCompleta, null, 2)], {
        type: "application/json",
      });
      saveAs(jsonBlob, "Informe-diagnostico.json");
      notification.success({
        message: "Éxito",
        description: "JSON exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar JSON:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el JSON.",
        duration: 3,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Space>
      <Tooltip title="Exportar datos en XLSX">
        <Button
          type="default"
          icon={<FileExcelOutlined />}
          onClick={exportToExcel}
          loading={loading || loadingExcel}
          disabled={loading || loadingExcel}
          style={{
            backgroundColor: "#52c41a",
            borderColor: "#52c41a",
            color: "white",
          }}
        />
      </Tooltip>

      <Tooltip title="Exportar datos en JSON">
        <Button
          type="default"
          icon={<FileTextOutlined />}
          onClick={exportToJSON}
          loading={loading || loadingJson}
          disabled={loading || loadingJson}
          style={{
            backgroundColor: "#C2BCBC",
            borderColor: "#C2BCBC",
            color: "white",
          }}
        />
      </Tooltip>
    </Space>
  );
};

export default Export_diagnostico_parte1;
